import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import Result from "./pages/Result";
import HomeComponent from "./Home";
import ResultProvider from "./component/context/ResultProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SingleResult from "./pages/singleResult";
import PageNotFound from "./pages/Notfound";

function scrollToTop() {
  window.scrollTo(0, 0);
}
function App() {
  return (
    <div className="App" onLoad={scrollToTop}>
      <ResultProvider>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        <Router>
          <Routes>
            <Route path="/" element={<HomeComponent />} />
            <Route path="/result" element={<Result />} />
            <Route path="/result/:id" element={<SingleResult />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Router>
      </ResultProvider>
    </div>
  );
}

export default App;
